import home from '../public/locales/en/home.json';
import { elementsPackageI18nConfigOptions } from '@elements-financial/elements';

export const i18nConfig = {
  returnNull: false,
  supportedLngs: ['en'],
  defaultNS: 'common',
  fallbackLng: 'en',
  react: { useSuspense: false },
  resources: {
    en: {
      home,
      ...elementsPackageI18nConfigOptions.resources.en,
    },
  },
};
